import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=bf032350&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=bf032350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf032350",
  null
  
)

export default component.exports